import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './index.scss';

const Header = ({ headerTitle = '' }) => (
    <div className={css.headerComponent}>
        <div className={css.headerText}>{headerTitle}</div>
    </div>
);

Header.propTypes = {
    headerTitle: PropTypes.string
};

export default styleable(css)(Header);



// WEBPACK FOOTER //
// ./app/components/header/index.js